"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = void 0;
class Permission {
}
exports.Permission = Permission;
//# sourceMappingURL=permission.js.map